import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";
import { Icon } from "../IconStyled";

export const ExclamationIcon = ({ title, theme }) => (
  <Icon>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="50px"
      height="50px"
      viewBox="0 0 50 50"
      version="1.1"
    >
      <title>{title}</title>
      <defs />
      <g
        id="190325_Abode"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="claim-closed/no-longer-available"
          transform="translate(-135.000000, -120.000000)"
          fill={theme.primaryColor}
          fillRule="nonzero"
        >
          <g id="icon/help_blue" transform="translate(135.000000, 120.000000)">
            <path
              d="M25.3424658,0 C16.6413798,0.00326711467 8.58614525,4.59218271 4.14611181,12.075164 C-0.293921629,19.5581454 -0.461374816,28.8272829 3.70547945,36.4657534 L0.684931507,48.4657534 C0.614905574,48.7058423 0.681303855,48.9650118 0.85814604,49.141854 C1.03498823,49.3186961 1.29415766,49.3850944 1.53424658,49.3150685 L13.5342466,46.3150685 C22.5702807,51.2330837 33.7100811,50.0241649 41.48075,43.2822444 C49.2514189,36.540324 52.0196784,25.6824522 48.425504,16.0430178 C44.8313297,6.40358334 35.6301628,0.00865033702 25.3424658,0 Z M25.3424658,47.9452055 C21.3577786,47.9417295 17.4406348,46.915867 13.9657534,44.9657534 C13.8138795,44.880115 13.6350629,44.8556196 13.4657534,44.8972603 L2.30821918,47.6917808 L5.09589041,36.5342466 C5.13753109,36.3649371 5.11303566,36.1861205 5.02739726,36.0342466 C-0.108025203,26.8620252 1.53803791,15.3865372 9.0447004,8.02771757 C16.5513629,0.668897947 28.0573193,-0.748605956 37.125589,4.56822513 C46.1938587,9.88505621 50.5759297,20.6178938 47.8202627,30.7622769 C45.0645956,40.9066599 35.8544686,47.94725 25.3424658,47.9452055 Z"
              id="Shape"
            />
            <path
              d="M25.3424658,10.4863014 C22.8950121,10.4863014 20.9109589,12.4703546 20.9109589,14.9178082 C20.9109589,17.3652619 22.8950121,19.3493151 25.3424658,19.3493151 C27.7899194,19.3493151 29.7739726,17.3652619 29.7739726,14.9178082 C29.770201,12.4719185 27.7883554,10.490073 25.3424658,10.4863014 Z M25.3424658,17.9794521 C24.1041464,17.9794521 22.98776,17.2335065 22.5138757,16.0894486 C22.0399914,14.9453907 22.3019326,13.6285231 23.1775566,12.7528991 C24.0531806,11.8772751 25.3700482,11.6153338 26.5141061,12.0892181 C27.658164,12.5631024 28.4041096,13.6794889 28.4041096,14.9178082 C28.4041096,16.6087074 27.033365,17.9794521 25.3424658,17.9794521 Z"
              id="Shape"
            />
            <path
              d="M25.6027397,21.7260274 L25.0890411,21.7260274 C23.197655,21.7260274 21.6643836,23.2592988 21.6643836,25.1506849 L21.6643836,36.9041096 C21.6643836,38.7954957 23.197655,40.3287671 25.0890411,40.3287671 L25.6027397,40.3287671 C27.4941259,40.3287671 29.0273973,38.7954957 29.0273973,36.9041096 L29.0273973,25.1506849 C29.0273973,23.2592988 27.4941259,21.7260274 25.6027397,21.7260274 Z M27.6575342,36.9041096 C27.6575342,38.0389413 26.7375714,38.9589041 25.6027397,38.9589041 L25.0890411,38.9589041 C23.9542094,38.9589041 23.0342466,38.0389413 23.0342466,36.9041096 L23.0342466,25.1506849 C23.0342466,24.0158533 23.9542094,23.0958904 25.0890411,23.0958904 L25.6027397,23.0958904 C26.7375714,23.0958904 27.6575342,24.0158533 27.6575342,25.1506849 L27.6575342,36.9041096 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  </Icon>
);

ExclamationIcon.propTypes = {
  title: PropTypes.string,
  theme: PropTypes.shape({
    primaryColor: PropTypes.string
  }).isRequired
};

ExclamationIcon.defaultProps = {
  title: "Exclamation Icon"
};

export default withTheme(ExclamationIcon);
